import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import styles from './PhoneInputField.css';

function PhoneInputField({ value, onChange, errorText, label, id, defaultCountry, inputClassName, hideErrorMessage }) {
    const baseClassName = errorText ? styles.phoneInputError : styles.phoneInput;

    return (
        <div className={styles.root}>
            {label && (
                <label className={styles.label} htmlFor={id}>
                    {label}
                </label>
            )}
            <PhoneInput
                id={id}
                international
                limitMaxLength
                addInternationalOption={false}
                defaultCountry={defaultCountry}
                value={value}
                onChange={onChange}
                className={inputClassName ? `${baseClassName} ${inputClassName}` : baseClassName}
            />
            {errorText && !hideErrorMessage && <p className={styles.alert}>{errorText}</p>}
        </div>
    );
}

PhoneInputField.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    errorText: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
    defaultCountry: PropTypes.string,
    inputClassName: PropTypes.string,
    hideErrorMessage: PropTypes.bool
};

PhoneInputField.defaultProps = {
    value: '',
    errorText: '',
    label: '',
    id: 'phone',
    defaultCountry: 'US',
    inputClassName: '',
    hideErrorMessage: false
};

export {
    PhoneInputField,
    isValidPhoneNumber
};
